import {nsLanguage} from "../../../../util/nsLanguage";

export namespace nsSystemAccessSearch {
    import toLocaleString = nsLanguage.toLocaleString;

    export function numAffectedObjectsText(num: number): string {
        return `${toLocaleString(num)} ((permission|ac|n:${num}))`
    }
}